<template>
  <v-checkbox
    dense
    ref="checkbox"
    hide-details="auto"
    v-bind:class="computedClass"
    v-bind="$attrs"
    v-model="$attrs.value"
    v-on="$listeners"
    v-on:change="onChangeHandler"
  >
    <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: 'AnchorCheckbox',
  computed: {
    computedClass: vm => {
      const classes = vm.$attrs.classes || '';
      return `${classes} my-1`.trim();
    },
  },
  methods: {
    onChangeHandler(value) {
      const checkboxRef = this.$refs.checkbox;
      let val = Boolean(value);
      if (value) {
        if (checkboxRef.trueValue) val = checkboxRef.trueValue;
      } else if (checkboxRef.falseValue) val = checkboxRef.falseValue;
      return this.$emit('input', val);
    },
  },
};
</script>
